// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"496":"78ea8e20","846":"35036e26","965":"5936de61"}[chunkId] + ".chunk.css";
};